<template>
    <div class="container">
        <div class="header">
            <img class="header-bg" src="@img/header.png" />
            <img class="logo" src="@img/logo.png" />
        </div>
        <!-- <login-method-view v-if="currentMethod === 0" @click="onClickMethod" /> -->
        <phone-login-view v-if="currentMethod === 2" :phone.sync="phone" :code.sync="code" :loading="loading"
            :verify-disable="verifyDisable" :verify-text="verifyText" @verify="onVerify" @login="onLogin" />
    </div>
</template>

<script>
import LoginMethodView from '@/components/login/LoginMethodView.vue';
import PhoneLoginView from '@/components/login/PhoneLoginView.vue';
import { mapState } from 'vuex';
import API from '@/api';

export default {
    components: {
        LoginMethodView,
        PhoneLoginView,
    },
    data() {
        return {
            loading: false,
            verifyDisable: false,
            verifyText: '获取验证码',
            timer: undefined,
            phone: '',
            code: '',
            currentMethod: 2,
            hospitalId: undefined,
        };
    },
    computed: {
        ...mapState({
            userStore: state => state.user,
        }),
        
    },
    async mounted() {
        if (this.isCode()) {
            const urlParams = Object.fromEntries(window.location.search.slice(1).split('&').map(v => v.split('=')));
            // const access_token = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=wx63df933236160593&secret=6e2fe003b24447704e6c607d661bdc16&code=${urlParams.code}&grant_type=authorization_code`
            // const userInfo = `https://api.weixin.qq.com/sns/userinfo?access_token=ACCESS_TOKEN&openid=OPENID&lang=zh_CN`
        }

        this.hospitalId = this.$route.query.hospitalId;
    },
    methods: {
        onClickMethod(index) {
            if (index === 2) {
                this.currentMethod = 2;
            } else {
                this.fastLogin();
            }
        },
        fastLogin() {
            // Fast login logic here
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx63df933236160593&redirect_uri=${encodeURIComponent('http://192.168.31.35:8080/children/h5/wxlogin')}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
        },
        onVerify() {
            if (this.timer) {
                return;
            }
            this.sendVerifyCode();
        },
        async onLogin() {
            if (this.phone === '' || this.code === '') {
                this.$toast('请输入手机号和验证码');
                return;
            }
            if (!isPhoneNumber(this.phone)) {
                this.$toast('手机号码不正确');
                return;
            }
            // this.$toast.loading({
            //     message: '登录中...',
            //     forbidClick: true,
            // });
            try {
                const data = await API.login({ phone: this.phone, verificationCode: this.code, type: 1, hospitalId: this.hospitalId });
                data.mobile = this.phone;
                this.$store.dispatch('user/setUser', data);
                let userInfo = {}
                // const data1 = await API.userInfoRequest({ id: data.uid });
                // const accountInfoModel = new AccountInfoModel({
                //     userInfo,
                //     result
                // }, this.phone)
                this.$toast('登录成功');
                const redirectTo = this.$store.state.redirectTo;
                if (redirectTo) {
                    this.$router.replace(redirectTo);
                    this.$store.commit('setRedirectTo', null); // 清空目标路由
                } else {
                    this.$router.replace({ name: 'Home' })
                }
            } catch (error) {
                // this.$toast.clear();
                this.$toast(error);
            }
        },
        async sendVerifyCode() {
            if (!isPhoneNumber(this.phone)) {
                this.$toast('请输入正确手机号');
                return;
            }
            try {
                await API.verifyCode({
                    toPhone: this.phone,
                    smsType: 19
                });
                this.startTimer();
            } catch (error) {
                this.$toast(error);
            }
        },
        startTimer() {
            let timerNum = 60;
            this.verifyText = timerNum + 's';
            const t = setInterval(() => {
                timerNum--;
                if (timerNum !== 0) {
                    this.verifyText = timerNum + 's';
                    return;
                }
                clearInterval(t);
                this.verifyDisable = false;
                this.verifyText = '获取验证码';
                this.timer = undefined;
            }, 1000);
            this.verifyDisable = true;
            this.timer = t;
        },
        isCode() {
            return window.location.search.includes('code=')
        },

    },
};
</script>

<style scoped lang="scss">
.container {
    height: 100%;
    width: 100%;
}

.header {
    width: 100%;
    height: 190px;
    position: relative;
}

.header-bg {
    width: 100%;
    height: 100%;
}

.logo {
    position: absolute;
    width: 83px;
    height: 80px;
    top: 64px;
    left: 147px;
}
</style>
